import styled from '@emotion/styled';

const EditorContentWrapper = styled('div')({
  padding: 12,
});

export default EditorContentWrapper;
